import {Panes, RadioGroup, Select} from '@management-ui/core';
import React, {useEffect, useState} from 'react'
import FormErrors from '../../components/FormErrors';
import withTemplatedFields from '../JobDetailsForm/withTemplatedFields';
import orderOptions from './orderOptions';

const Fields = ({order, job = {}, prefix = '', fields, errors}) => {
  const [companies, setCompanies] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const {companies, contacts, locations} = orderOptions(order);
    setCompanies(companies);
    setContacts(contacts);
    setLocations(locations);
  }, [order]);

  return (
    <Panes
      entity={job}
      prefix={prefix}
      panes={[
        {
          title: 'Job Details',
          fields: [
            ...fields,
            ...(errors.length ? [(
              <FormErrors>
                {errors.map((error, index) => <li key={index}>{error}</li>)}
              </FormErrors>
            )] : []),
            <Select
              name="company_id"
              prefix={prefix}
              options={companies}
              label="Company"
            />,
            <Select
              name="contact_id"
              prefix={prefix}
              options={contacts}
              label="Contact"
            />,
            <Select
              name="end_user_id"
              prefix={prefix}
              options={contacts}
              label="End User"
            />,
            <RadioGroup
              name="location_id"
              prefix={prefix}
              options={locations}
              label="Location"
            />
          ]
        }
      ]}
      title={null}
    />
  );
};

export default withTemplatedFields(Fields);
